import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";

export type PsAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatPsToastLabel(code: string | undefined): string {
    const t = typeof code === "string" ? code.trim() : "";
    return t.length > 0 ? t : EntityLabels.physicalState;
}

export function getPsAdminActionSuccessMessage(
    kind: PsAdminConfirmKind,
    code: string | undefined
): string {
    const label = formatPsToastLabel(code);
    const successByKind: Record<PsAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

type PsRow = { id: string; code: string };

export const buildPsAdminPagedListActions = (openConfirm: (kind: PsAdminConfirmKind, item: PsRow) => void) =>
    buildRecordLifecyclePagedListActions<PsRow>(openConfirm, { activeMember: "isActive" });
